/** @jsx jsx */

import { jsx, Link, Divider, Text, Flex } from 'theme-ui'
import { string } from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { Fragment } from 'react'
import { Window } from '../../../icons'
import Mic from '../../../icons/Mic'
const peerStoriesLink =
  'https://cfninsights.iad1.qualtrics.com/jfe/form/SV_a9He77i2cUf67PM'

export default function SocialMediaButton({ headline, title, link }) {
  const isPeerStoriesLink = link === peerStoriesLink
  const renderButton = () => {
    return (
      <Flex
        data-automation-id="sub-section-button"
        sx={{
          display: 'inline-flex',
          width: 'auto',
          minWidth: 0,
          border: '1px solid #83928B',
          backgroundColor: '#D6DBD8',
          paddingY: '3px',
          paddingX: '11px',
          fontSize: '14px',
          fontWeight: 500,
          alignItems: 'center',
          color: 'black',
          mt: '11px',
          '&:hover': {
            cursor: 'pointer',
            boxShadow: '2px 2px 4px 0 #6F6C69',
          },
          svg: {
            marginRight: '12px',
          },
        }}
      >
        {isPeerStoriesLink ? <Mic /> : <Window />}
        {title}
      </Flex>
    )
  }
  return (
    <Fragment>
      <Divider sx={{ width: '100%', my: 4, color: '#979491' }} />
      <Text variant="xSmallText">{headline}</Text>
      {link.includes('http') ? (
        <Link
          onClick={e => {
            e.stopPropagation()
          }}
          target="_blank"
          href={link}
          data-automation-id="sub-section-link"
          sx={{
            textDecoration: 'none',
            display: 'inline-block',
            color: 'black',
          }}
        >
          {renderButton()}
        </Link>
      ) : (
        <GatsbyLink
          to={link}
          state={{ thirdPartyVendor: '2' }}
          data-automation-id="sub-section-link"
          sx={{
            textDecoration: 'none',
            color: 'black',
          }}
        >
          {renderButton()}
        </GatsbyLink>
      )}
    </Fragment>
  )
}

SocialMediaButton.propTypes = {
  title: string,
  link: string,
  headline: string,
}
